var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "add-review-notification",
      class: "add-review-notification--" + _vm.messageType
    },
    [
      _c(
        "button",
        {
          staticClass: "close",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.hideNotification($event)
            }
          }
        },
        [
          _c("svg", { attrs: { width: "24", height: "24" } }, [
            _c("use", { attrs: { "xlink:href": "/sprite.svg#icon-close" } })
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "add-review-notification__text" }, [
        _vm._v(_vm._s(_vm.text))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }